import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import * as files from '../../assets/files.json';

const Footer = () => {
  useEffect(() => {
    setTimeout(() => {
      const bodyHeight = document.body.offsetHeight;
      const windowHeight = window.innerHeight;
      const diff = windowHeight - bodyHeight;
      if (diff > 0) {
        const footer: HTMLElement = document.querySelector('.footer-content');

        footer && (footer.style.marginTop = `${diff}px`);
      } else if (windowHeight < bodyHeight) {
        document.body.style['overflowY'] = 'scroll';
      }
    }, 1500);
  }, []);
  return (
    <div class="footer-content">
      <div class="row px-3 py-5" style="background-color:azure;--bs-gutter-x:0">
        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <img src={files.logo} width="200" />
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <p class="text-center">
            Seedbox Philippines is a digital platform that lets you invest in
            funds online.
          </p>
          <p class="text-center">
            Email us at pera.support@seedbox.ph, send a message using chat box{' '}
            <img src={files.logo_chat} width="40" />
          </p>
          <p class="text-center">
            Customer service chat available Monday to Friday, 10:00 am to 3:00
            pm except holidays.{' '}
          </p>
          <p class="text-center">
            You can find us on <img src={files.logo_fb} width="40" />{' '}
            <img src={files.logo_ig} width="40" />
          </p>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3" />
      </div>
      <div style="background-color: #0079c2; ">
        <div class="py-3">
          <p class="text-center">
            Copyright @ 2023 ATR Asset Management, Inc and Seedbox Technologies,
            Inc
          </p>
          <p class="text-center">All Rights Reserved, version 1.0</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
